import styled from "styled-components";

export const TruckTypeFormModalStyle = styled.div`

`;
